export const ImageIcon = ({ size = 24, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M26.01 32.229H7.92a6.13 6.13 0 0 1-5.257-2.932 6.16 6.16 0 0 1-.269-6.021l2.437-4.888c.793-1.587 2.068-2.578 3.499-2.734 1.43-.156 2.89.552 3.995 1.927l.312.396c.623.765 1.345 1.176 2.054 1.105.708-.056 1.36-.566 1.841-1.43l2.678-4.831c1.105-1.998 2.578-3.032 4.18-2.961 1.586.085 2.946 1.275 3.852 3.372l4.435 10.355a6.16 6.16 0 0 1-.524 5.837 6.07 6.07 0 0 1-5.143 2.805M8.727 17.779c-.057 0-.114 0-.17.014-.709.071-1.36.638-1.828 1.559l-2.436 4.887a4.05 4.05 0 0 0 .17 3.953 4.03 4.03 0 0 0 3.456 1.926h18.077a3.99 3.99 0 0 0 3.386-1.827c.765-1.162.892-2.55.34-3.825L25.288 14.11c-.539-1.275-1.29-2.054-2.012-2.083-.666-.042-1.53.666-2.21 1.87l-2.678 4.831c-.821 1.473-2.11 2.394-3.513 2.522-1.402.113-2.833-.567-3.896-1.898l-.311-.397c-.595-.78-1.275-1.176-1.941-1.176m1.147-5.383a5.323 5.323 0 0 1-5.312-5.313 5.314 5.314 0 0 1 5.312-5.312 5.314 5.314 0 0 1 5.313 5.313 5.314 5.314 0 0 1-5.313 5.312m0-8.5a3.19 3.19 0 0 0-3.187 3.188 3.19 3.19 0 0 0 3.187 3.187 3.19 3.19 0 0 0 3.188-3.188 3.19 3.19 0 0 0-3.188-3.187"
      fill="#aab3d0"
    />
  </svg>
);
